import { ExperienceAttachment } from './experience-attachment';
import { FormGroup } from '@angular/forms';
export class Experience {
    public id: string;
    public _id: string;
    public title: string;
    public company: string;
    public fromDate: Date | null;
    public toDate: Date | null;
    public currentJob: boolean = false;
    public description: string;
    public attachments: ExperienceAttachment[] = [];
    public hidden: boolean;

    public static parseForm(form: FormGroup): Experience {
        let id = '_' + Math.random().toString(36).substr(2, 9);
        let experience = new Experience();
        experience = Object.assign(experience, form.value);
        experience._id = id;
        experience.fromDate = new Date(form.value.fromDate["year"], form.value.fromDate["month"], form.value.fromDate["day"]);
        if(!experience.currentJob) {
            experience.toDate = new Date(form.value.toDate["year"], form.value.toDate["month"], form.value.toDate["day"]);
        } else {
            experience.toDate = null;
        }

        
        return experience;
    }

    public static parse(jsonData): Experience {
        let experience = new Experience();
        experience = Object.assign(experience, jsonData);
        experience.fromDate = new Date(experience.fromDate);
        experience.toDate = new Date(experience.toDate);

        return experience;
    }
}

